export default {
  eduzz: {
    landscape: {
      width: 560,
      height: 620,
    },
    portrait: {
      width: 620,
      height: 560,
    },
  },
  hotmart: {
    landscape: {
      width: 560,
      height: 315,
    },
    portrait: {
      width: 407,
      height: 724,
    },
  },
}
